module.exports = __webpack_public_path__ + "static/QRforRelease-2dac40c3d8b67fc787491ee1a7db7b3e.png";